import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const CameraIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-camera', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.00006 6.07692C6.75731 6.07692 5.75006 7.11 5.75006 8.38462C5.75006 9.65923 6.75731 10.6923 8.00006 10.6923C9.24281 10.6923 10.2501 9.65923 10.2501 8.38462C10.2501 7.11 9.24281 6.07692 8.00006 6.07692ZM8.00006 7.23077C8.62031 7.23077 9.12506 7.74846 9.12506 8.38462C9.12506 9.02077 8.62031 9.53846 8.00006 9.53846C7.37981 9.53846 6.87506 9.02077 6.87506 8.38462C6.87506 7.74846 7.37981 7.23077 8.00006 7.23077Z'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.32306 3H6.67706C6.10931 3 5.58956 3.32923 5.33606 3.85L5.00006 4.53846H3.50006C2.67206 4.53846 2.00006 5.22769 2.00006 6.07692V11.4615C2.00006 12.3108 2.67206 13 3.50006 13H12.5001C13.3288 13 14.0001 12.3108 14.0001 11.4615V6.07692C14.0001 5.22769 13.3288 4.53846 12.5001 4.53846H11.0001L10.6648 3.85C10.4106 3.32923 9.89156 3 9.32306 3ZM9.32306 4.53846L10.0731 6.07692H12.5001V11.4615H3.50006V6.07692H5.92706L6.67706 4.53846H9.32306Z'
      />
    </svg>
  );
};

export default CameraIcon;
